export default "__VITE_ASSET__DlZ9uGso__"